import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';

import { intlMessage, venuePropTypes } from 'constants/propTypes';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItemCheckbox } from 'components/Dropdown2';
import Message from 'components/Message';

const messages = defineMessages({
  label: {
    id: 'venue-multi-selector.label',
    defaultMessage: 'Venues',
  },
  allVenues: {
    id: 'venue-multi-selector.all-venues',
    defaultMessage: 'All venues',
  },
  selectedItem: {
    id: 'venue-multi-selector.selected-item',
    defaultMessage: '{selectedVenuesCount, plural, one {# venue} other {# venues}}',
  },
  venueName: {
    id: 'venue-multi-selector.venue-name',
    defaultMessage: '{venueSubtitle, select, undefined {{venueName}} other {{venueName} ({venueSubtitle})}}',
  },
});

const VenueMultiSelector = props => {
  const {
    venues,
    selectedVenueIds,
    disabledVenueIds = [],
    onChange,
    onOpen,
    attachment = 'right',
    hideSingleVenue = true,
    disabled = false,
    labels = {},
  } = props;
  if (hideSingleVenue && venues.length < 2) return null;

  const allSelected = venues.length === selectedVenueIds.length;
  const showSingleVenueName = disabled && venues.length === 1;

  return (
    <Dropdown attachment={attachment} closeOnSelect={false} disabled={disabled} onOpen={onOpen}>
      <DropdownToggle label={labels.label || messages.label}>
        {showSingleVenueName ? (
          <Message message={messages.venueName} values={venues[0]} />
        ) : (
          <Message
            message={
              allSelected ? labels.allSelected || messages.allVenues : labels.selectedCount || messages.selectedItem
            }
            values={{ selectedVenuesCount: selectedVenueIds.length, venuesCount: venues.length }}
          />
        )}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItemCheckbox
          isSelectAll
          isChecked={allSelected}
          onClick={() => {
            const updatedArr = allSelected ? [] : venues.map(({ venueId }) => venueId);
            onChange(updatedArr);
          }}
        />
        {venues.map(venue => {
          const { venueId } = venue;
          return (
            <DropdownItemCheckbox
              key={venueId}
              disabled={disabledVenueIds.includes(venueId)}
              isChecked={selectedVenueIds.includes(venueId)}
              onClick={checked => {
                const updatedArr = checked
                  ? selectedVenueIds.concat(venueId)
                  : selectedVenueIds.filter(id => id !== venueId);
                onChange(updatedArr);
              }}>
              <Message message={messages.venueName} values={venue} />
            </DropdownItemCheckbox>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};

VenueMultiSelector.propTypes = {
  onChange: PropTypes.func,
  onOpen: PropTypes.func,
  selectedVenueIds: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.arrayOf(PropTypes.string)]),
  venues: PropTypes.arrayOf(PropTypes.shape(venuePropTypes)),
  disabledVenueIds: PropTypes.arrayOf(PropTypes.number),
  attachment: PropTypes.oneOf(['left', 'right', 'center']),
  hideSingleVenue: PropTypes.bool,
  disabled: PropTypes.bool,
  labels: PropTypes.shape({
    label: intlMessage,
    allSelected: intlMessage,
    selectedCount: intlMessage,
  }),
};

export default VenueMultiSelector;
